import React from "react";
import "../PrintAudit.style.css";
import { Typography } from "@mui/material";
import dayjs from "dayjs";

const FooterSection = ({ Details }) => {
  const { auditeesSuggestion, auditorsSuggestion, updatedAt, auditorName } =
    Details;
  return (
    <div className="pdf-footer-container">
      <div className="print-ams-footer-heading">
        <div className="pt-2" style={{ borderBottom: "3px solid #cfcfcf" }}>
          <Typography className="inter-medium-500" variant="h6">
            Audit Closure Remarks:
          </Typography>
        </div>
      </div>
      <div className="auditees-suggestion-container">
        <div className="py-2">
          <Typography className="inter-medium-500" variant="h6">
            Auditee's Statement:
          </Typography>
          <span>
            {auditeesSuggestion && auditeesSuggestion
              ? auditeesSuggestion
              : "Not Available"}
          </span>
        </div>
      </div>
      <div className="auditors-suggestion-container">
        <div className="py-2">
          <Typography className="inter-medium-500" variant="h6">
            Auditor's Statement:
          </Typography>
          <span>
            {auditorsSuggestion && auditorsSuggestion
              ? auditorsSuggestion
              : "Not Available"}
          </span>
        </div>
      </div>
      <div className="print-wp-footer-container">
        <div className="px-3 py-2 d-flex w-100">
          <div className="w-25">
            <strong>Date Of Closure</strong>
            <br />
            <span>
              {dayjs(updatedAt?._seconds * 1000).format("DD MMM YYYY") ||
                "Not Available"}
            </span>
          </div>
          <div className="w-50">
            <strong>Closed By</strong> <br />
            <span>{auditorName || "Not Available"}</span>
          </div>
          <div className="w-25 d-flex align-items-end justify-content-center">
            <strong>Signature</strong>{" "}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterSection;
